/*
 * ATN Country Intelligence - shared accordion
 *
 * Turns a panel into a collapsible accordion below a breakpoint. Used by the
 * hero "About" panel and the data list panels, which are open on desktop and
 * collapsed on mobile.
 *
 * Markup contract:
 *   <div data-atn-acc data-acc-bp="749" data-acc-open="false">
 *     <button data-atn-acc-toggle>...<span data-atn-acc-chevron></span></button>
 *     <div data-atn-acc-panel>...</div>
 *   </div>
 *
 * Above the breakpoint the toggle is hidden and the panel is always shown.
 */
(function () {
  'use strict';

  if (window.atnCiAccordion) return;
  window.atnCiAccordion = true;

  function Accordion(root) {
    this.root = root;
    this.toggle = root.querySelector('[data-atn-acc-toggle]');
    this.panel = root.querySelector('[data-atn-acc-panel]');
    if (!this.toggle || !this.panel) return;

    this.bp = parseInt(root.getAttribute('data-acc-bp'), 10) || 749;
    this.openByDefault = root.getAttribute('data-acc-open') === 'true';
    this.query = window.matchMedia('(max-width: ' + this.bp + 'px)');

    this.onToggle = this.onToggle.bind(this);
    this.apply = this.apply.bind(this);

    this.toggle.addEventListener('click', this.onToggle);
    if (this.query.addEventListener) {
      this.query.addEventListener('change', this.apply);
    } else if (this.query.addListener) {
      this.query.addListener(this.apply);
    }

    this.apply();
  }

  Accordion.prototype.apply = function () {
    if (this.query.matches) {
      this.root.classList.add('is-accordion');
      this.setOpen(this.openByDefault);
    } else {
      this.root.classList.remove('is-accordion');
      this.root.classList.remove('is-open');
      this.panel.removeAttribute('hidden');
      this.toggle.setAttribute('aria-expanded', 'true');
    }
  };

  Accordion.prototype.setOpen = function (open) {
    this.root.classList.toggle('is-open', open);
    this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      this.panel.removeAttribute('hidden');
    } else {
      this.panel.setAttribute('hidden', '');
    }
  };

  Accordion.prototype.onToggle = function () {
    if (!this.query.matches) return;
    this.setOpen(!this.root.classList.contains('is-open'));
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-atn-acc]').forEach(function (el) {
      if (el.dataset.accReady === '1') return;
      el.dataset.accReady = '1';
      new Accordion(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor re-renders sections without a full page load
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();